module.exports = __webpack_public_path__ + "static/media/b.5d897ddd.jpg";